import { usePeriodIndex } from "hooks/periodIndex";
import { usePeriod } from "hooks/search";
import { mapLoadedUnpack } from "models/loaded";

export const useElectricalEnergyPrice = (): number | null => {
  const periodIndex = usePeriodIndex();
  const [period] = usePeriod(periodIndex);

  const electricalEnergyPrice = mapLoadedUnpack(
    period,
    (loadedPeriod) => loadedPeriod.electrical_energy_price
  );

  return electricalEnergyPrice;
};
